import script from "./ScaleDegreeLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScaleDegreeLabel.vue?vue&type=script&setup=true&lang=ts"

import "./ScaleDegreeLabel.vue?vue&type=style&index=0&id=1996f515&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1996f515"]])

export default __exports__